import {fsa, fsaError, fsaPayload} from '../helpers'

export const GET_ALL_LOCATIONS = 'showrooms/get all locations'
export const getAllLocations = fsa(GET_ALL_LOCATIONS)

export const GET_ALL_LOCATIONS_PENDING = 'showrooms/get all locations pending'
export const getAllLocationsPending = fsa(GET_ALL_LOCATIONS_PENDING)

export const GET_ALL_LOCATIONS_FAILURE = 'showrooms/get all locations failure'
export const getAllLocationsFailure = fsaError(GET_ALL_LOCATIONS_FAILURE)

export const GET_ALL_LOCATIONS_SUCCESS = 'showrooms/get all locations success'
/**
 * @param {Object} payload
 * @param {Object[]} payload.locations The array of location objects from the API
 */
export const getAllLocationsSuccess = fsaPayload(GET_ALL_LOCATIONS_SUCCESS)
